var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"width":"100%","height":"100%","min-height":"700px"},attrs:{"src":"/chatbot-proxy/chatbot/V0uV50qirXiTAYaw","frameborder":"0","allow":"microphone"}})
}
var staticRenderFns = []

export { render, staticRenderFns }